export const projectMap = {
    "503231": "dev",
    "501717": "prod"
} as const;

export const datoWarningYellow = 'rgb(255, 208, 10)';
export const datoNoticeGreen = 'rgb(62, 212, 3)';
export const datoFocusRed = 'rgb(219, 23, 43)';
export const datoLightBg = 'rgb(242, 242, 242)';